// extracted by mini-css-extract-plugin
var _1 = "bYo0KYaalB3OwBAJqcEX";
export { _1 as "body" }
